export const ESTABLISHMENT_TRANSFER_STATUS_DRAFT = "DRAFT";
export const ESTABLISHMENT_TRANSFER_STATUS_SUBMITTED = "SUBMITTED";
export const ESTABLISHMENT_TRANSFER_STATUS_ACCEPTED = "ACCEPTED";
export const ESTABLISHMENT_TRANSFER_STATUS_REJECTED = "REJECTED";
export const ESTABLISHMENT_TRANSFER_STATUS_CANCELED = "CANCELED";

export const establishmentTransferStatuses = [
  ESTABLISHMENT_TRANSFER_STATUS_DRAFT,
  ESTABLISHMENT_TRANSFER_STATUS_SUBMITTED,
  ESTABLISHMENT_TRANSFER_STATUS_ACCEPTED,
  ESTABLISHMENT_TRANSFER_STATUS_REJECTED,
  ESTABLISHMENT_TRANSFER_STATUS_CANCELED,
];
